import { createContext, useContext } from 'react';

import type { Location } from './utils';

export const NextLocationContext = createContext<Location | null>(null);

export default function useNextLocation(): Location {
  const nextLocation = useContext(NextLocationContext);
  if (nextLocation === null) {
    throw new Error(
      'useNextLocation must be used within a HybridHistoryRouter',
    );
  }
  return nextLocation;
}
